<div class="guest-container">
	<app-notification-message></app-notification-message>
	<router-outlet></router-outlet>
	<footer class="guest-footer">
		<a href="/privacy-policy" target="_blank">{{ 'legal.privacy_policy' | translate }}</a>
		<a href="/terms-conditions" target="_blank">{{ 'legal.terms_conditions' | translate }}</a>
	</footer>
</div>
